module.exports = __webpack_public_path__ + "6adbe2dd89d004cdcf7601e46aa44e13.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/car-s.png
// module id = 2500
// module chunks = 0